<template>
  <div style="height:100%;">
    <el-container style="height:100%;">
      <el-header>
        <h3>后台服务系统</h3>
        <top-nav></top-nav>
      </el-header>
      <el-container class="right-content">
        <el-aside width="230px">
          <!--左侧导航-->
          <left-nav id="el-aside" class="home-container leftnav"></left-nav>
        </el-aside>
        <el-container>
          <el-main id="el-Main">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
              <!--留存数据方法-->
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
            <!--<router-view></router-view>-->
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
 <script>
import LeftNav from '@/layout/LeftNav/index.vue'
import TopNav from '@/layout/TopNav/index.vue'
// import FooterNav from '@/layout/FooterNav/index.vue'
import store from '../store'
export default {
  name: 'Home',
  components: {
    LeftNav,
    TopNav
    // FooterNav
  },
  created() {
  },
  mounted() {
    document.getElementById('el-Main').style.maxHeight = document.documentElement.clientHeight - 45 + 'px'
    document.getElementById('el-aside').style.maxHeight = document.documentElement.clientHeight - 45 + 'px'
    window.onresize = () => {
      if (document.getElementById('el-aside')) {
        document.getElementById('el-aside').style.maxHeight = document.documentElement.clientHeight - 45 + 'px'
      }
      if (document.getElementById('el-Main')) {
        document.getElementById('el-Main').style.maxHeight = document.documentElement.clientHeight - 45 + 'px'
      }
    }
  },
  data() {
    return {
      // type: store.state.systemType
    }
  }
}
</script>
 <style scoped lang="less">
.leftnav {
  overflow: auto;
  overflow-y: auto;
  flex: 1;
}
#asd {
  width: 100%;
  height: 100%;
}
.el-main {
  padding: 0;
  background: #ffffff;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}
.el-aside {
  border-right: 1px solid #ececec;
  display: flex;
  flex-basis: auto;
}
.el-header {
  width: 100%;
  border-bottom: 2px solid #ececec;
  display: flex;
  justify-content: space-between;
  height: 45px !important;
  h3 {
    color: #2c2c2c;
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
}
</style>
